
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M31.878 19.277a.938.938 0 00-1.326 0l-3.228 3.228 5.745 5.746 3.228-3.229a.937.937 0 000-1.326l-4.42-4.419zM20.388 9.112a.937.937 0 000-1.326l-4.42-4.419a.937.937 0 00-1.325 0l-3.229 3.228 5.745 5.746 3.229-3.229zM20.388 29.442a7.187 7.187 0 11-10.165-10.165l5.61-5.61-5.745-5.746-5.61 5.61c-5.97 5.97-5.97 15.685 0 21.656a15.33 15.33 0 0021.655 0l5.61-5.61-5.745-5.746-5.61 5.61zM39.133 3.775c-.326-1.132-.968-2.099-1.81-2.721-.746-.552-2.697-1.553-5.401.347C30.994.766 30.082.399 29.2.309a3.83 3.83 0 00-2.74.754c-1.685 1.269-2.442 3.932-1.654 5.815 1.683 4.023 6.515 6.37 6.72 6.468a.937.937 0 00.809 0c.204-.098 5.036-2.444 6.72-6.468.366-.875.395-2.006.078-3.103z"}})])
          )
        }
      }
    